import { Agent, Statement } from '@xapi/xapi';
import {Guid} from '../../../../model/guid';

export class TinCanStatementsFactory {
  constructor(
    private readonly _courseGuid: Guid,
    private readonly _courseName: string,
    private readonly _xApiBaseUrl: string
  ) {}

  createOpened(actor: Agent): Statement {
    return {
      actor,
      verb: {
        id: 'http://activitystrea.ms/schema/1.0/open',
        display: {
          'en-US': 'Opened',
        },
      },
      object: {
        id: `${this._xApiBaseUrl}/xapi/activity-id/${this._courseGuid}`,
        objectType: 'Activity',
        definition: {
          name: {
            'en-US': this._courseName,
          },
          description: {
            'en-US': 'Student has opened the course.',
          },
        },
      },
    };
  }

  createCompleted(actor: Agent, durationISO: string): Statement {
    return {
      actor,
      verb: { id: 'http://adlnet.gov/expapi/verbs/completed', display: { 'en-US': 'completed' } },
      object: {
        id: `${this._xApiBaseUrl}/xapi/activity-id/${this._courseGuid}`,
        objectType: 'Activity',
        definition: {
          name: {
            'en-US': this._courseName,
          },
          description: {
            'en-US': 'Student has completed the course.',
          },
        },
      },
      result: {
        completion: true,
        duration: durationISO,
      },
    };
  }
}
